import { View } from "react-native";
import React, { useMemo } from "react";
import { SimplePlanPackageDetails, TicketCartDetails } from "features/types";
import PriceText from "./PriceText";
import { getAllItemsPrice } from "../helpers";
import FeeDetails from "./FeeDetails";
import { Divider } from "@ui-kitten/components";
import { formatCurrency } from "utils/appUtils";

const NewReservationCostDetails: React.FC<{
  charge: TicketCartDetails;
  refundDetails: TicketCartDetails;
  planPackage: SimplePlanPackageDetails;
}> = (props) => {
  const {
    charge: {
      priceType,
      feeItems,
      totalCredits,
      totalPoints,
      totalCreditCardCharges,
      totalPrice,
    },
    refundDetails,
    planPackage,
  } = props;

  const netCharge =
    Number(totalCreditCardCharges) -
    Number(refundDetails.totalCreditCardCharges ?? 0);

  const totalCostOfNewReservation =
    netCharge > 0
      ? totalCreditCardCharges
      : refundDetails.totalCreditCardCharges;

  return (
    <View>
      <PriceText
        label="Total"
        text={
          planPackage.allInclusivePrice
            ? formatCurrency(totalPrice)
            : getAllItemsPrice(props.charge, priceType)
        }
      />
      {!planPackage.allInclusivePrice && Boolean(feeItems?.length) && (
        <FeeDetails feeItems={feeItems!} />
      )}
      {/* if net charge is greater than 0, it means we are refunding some amount of money back */}
      {/* if net charge is negative, don't show refund amount */}
      {netCharge > 0 && (
        <>
          {Number(totalPoints) > 0 && (
            <PriceText
              label="Funds on Account"
              text={`(${formatCurrency(totalPoints, {
                priceType: priceType,
              })!})`}
              textColor="rgb(26, 142, 14)"
            />
          )}
          {Number(totalCredits) > 0 && (
            <PriceText
              label="Account Credit"
              text={`(${formatCurrency(totalCredits)!})`}
              textColor="rgb(26, 142, 14)"
            />
          )}
        </>
      )}
      <Divider style={{ marginVertical: 5 }} />

      <PriceText
        label="Total Cost of New Reservation"
        text={formatCurrency(totalCostOfNewReservation)}
        fontWeight="700"
      />
    </View>
  );
};

export default NewReservationCostDetails;
